import { __extends, __assign } from 'tslib';
import * as React from 'react';
import { UitkInput } from './uitk-input.esm.js';
var UitkPhoneInput = /** @class */function (_super) {
  __extends(UitkPhoneInput, _super);
  function UitkPhoneInput() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  UitkPhoneInput.prototype.render = function () {
    return React.createElement(UitkInput, __assign({}, this.props, {
      type: "tel"
    }));
  };
  UitkPhoneInput.displayName = 'UitkPhoneInput';
  return UitkPhoneInput;
}(React.Component);
export { UitkPhoneInput };